import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { ActionCreator } from "typescript-fsa";

import { Select } from "@ui/Select";
import * as actions from "../../actions";
import { LocalisationState } from "../../models";
import { getLanguage } from "../../selectors";

export interface LanguageSelectStateProps {
    language: string;
}

export interface LanguageSelectDispatchProps {
    languageChange: ActionCreator<string>;
}

type Props = LanguageSelectStateProps & LanguageSelectDispatchProps;

interface Option {
    value: string;
    label: React.ReactNode;
}

const LanguageSelect = ({ language, languageChange }: Props) => {
    const handleChange = (option: Option) => languageChange(option.value);
    const options: Option[] = [
        {
            value: "en-GB",
            label: (
                <span className="language-select__option">
                    <span className="fi fi-gb"></span>
                    <span className="language-select__optionText">English</span>
                </span>
            ),
        },
        {
            value: "fr-FR",
            label: (
                <span className="language-select__option">
                    <span className="fi fi-fr"></span>
                    <span className="language-select__optionText">Français</span>
                </span>
            ),
        },
    ];
    const value = language === "fr-FR" ? options[1] : options[0];
    return (
        <div className="language-select">
            <Select<{ value: string }>
                isMulti={false}
                value={value}
                options={options}
                onChange={handleChange}
            />
        </div>
    );
};

// Map the state to the component.
function mapStateToProps(state: LocalisationState) {
    return {
        language: getLanguage(state),
    } as LanguageSelectStateProps;
}

// Map the action to the component
function mapDispatchToProps(dispatch: Dispatch<LocalisationState>) {
    return {
        languageChange: bindActionCreators(actions.languageChange, dispatch),
    } as LanguageSelectDispatchProps;
}

// Connect the component to Redux.
const ConnectedLanguageSelect = connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);

export {
    LanguageSelect as LanguageSelectPresenter,
    ConnectedLanguageSelect as LanguageSelect,
};
